import type { WidgetKind } from "@playbookai/types";
import type { DashboardItem } from "@playbookai/ui";
import { dashboardWidgetModule } from "@playbookai/dashboard-client";
import { getDashboardWidgetContract } from "@playbookai/widget-schemas";

/**
 * Home presentation policy only; backend dataset authorization remains
 * authoritative. `availableModules` holds installable keys (ADR-0100), so the
 * KPI widgets follow KPI Manager like the others follow their module; the
 * kind → module map is the one every dashboard host reads.
 */
export function isHomeWidgetAvailable(
  kind: WidgetKind,
  availableModules: ReadonlySet<string>,
): boolean {
  // Temporarily suppressed without deleting saved instances or personal data.
  if (kind === "moodCheck") return false;
  // Use the same product availability as the Add menu for saved Home cards.
  // Older dashboards can still contain kinds that are no longer offered.
  if (getDashboardWidgetContract(kind)?.availableForNewInstances === false)
    return false;
  const module = dashboardWidgetModule(kind);
  return module === null || availableModules.has(module);
}

/** Reorder visible slots while keeping hidden instances in their saved positions. */
export function mergeHomeWidgetOrder(
  saved: readonly DashboardItem[],
  visible: readonly DashboardItem[],
): DashboardItem[] {
  const visibleIds = new Set(visible.map((item) => item.instanceId));
  let index = 0;
  return saved.map((item) =>
    visibleIds.has(item.instanceId) ? visible[index++]! : item,
  );
}
